import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  flex-direction: column;
`;

export const ContainerStatus = styled.div`
  display: flex;
  flex-direction: column;
  padding: 50px;
  justify-content: center;
  align-items: center;
  width: 500px;
  height: 250px;
  background-color: white;
  border: 1px solid #D4D4D4;
  border-radius: 3px;
  gap: 10px;
`;

export const Title = styled.h1`
  font-weight: 500;
`;

export const Subtitle = styled.p`
  font-size: 16px;
  color: #192c47;
`;

export const Logo = styled.img`
  max-width: 220px;
`;

export const Video = styled.video`
  display: none;
`;
